import { Component, input } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { addIcons } from 'ionicons';
import { checkmarkCircle, closeCircle, warning, informationCircle } from 'ionicons/icons';

export type NotificationType = 'success' | 'error' | 'warning' | 'info';

export interface Notification {
  type: NotificationType;
  message: string;
  duration?: number;
}

@Component({
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  styleUrls: ['./notification-popup.component.scss'],
  standalone: true,
  imports: [SharedModule]
})
export class NotificationPopupComponent {
  notification = input<Notification | null>(null);

  constructor() {
    addIcons({ checkmarkCircle, closeCircle, warning, informationCircle });
  }

  getIconClass(): string {
    switch (this.notification()?.type) {
      case 'success':
        return 'checkmark-circle';
      case 'error':
        return 'close-circle';
      case 'warning':
        return 'warning';
      case 'info':
        return 'information-circle';
      default:
        return 'information-circle';
    }
  }
}
